<template>
  <div>

    <div class="p-8">
      
      <m-row>
        <m-col lg="12">
          <p class="mt-4" style="font-weight: bold;">Headerbild</p>
          <div class="d-flex">
            <div v-if="xl_preview_url || settings.public_event.image_xl" style="width: 25%; max-height: 130px; overflow:hidden;">
              <img
                :src="xl_preview_url || ('data:image/png;base64,' + settings.public_event.image_xl)"
                alt="Preview"
                style="width: 100%;"
              />
            </div>
            <div :style="{ width: (xl_preview_url || settings.public_event.image_xl) ? '75%' : '100%' }">
              <memlist-image-dropzone-upload
                v-model="settings.public_event.image_xl_file_id"
                :base64_preview="settings.public_event.image_xl"
                @uploaded="on_image_xl_uploaded"
              />
            </div>
          </div>
        </m-col>
      </m-row>
      

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input 
            v-model="settings.public_event.header_text"
            :title="$t('EVENT.HEADER_TEXT')"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <memlist-text-input 
            v-model="settings.public_event.subheader_text"
            :title="$t('EVENT.SUBHEADER_TEXT')"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <tip-label :tip="$t('EVENT.TIP_SUBEVENTS')">
            <h5 class="mb-4 mt-4">{{$t('EVENT.HEADER_SUBEVENTS')}}</h5>
          </tip-label>
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col md="8">
          <memlist-checkbox 
            v-model="settings.subevents"
            :title="$t('EVENT.CHECKBOX_SUBEVENTS')"
          />
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col lg="12">
          <tip-label :tip="$t('EVENT.TIP_ENABLED_EVENT_DINTERO')">
            <h5 class="mb-4 mt-4">{{$t('EVENT.HEADER_ENABLED_EVENT_DINTERO')}}</h5>
          </tip-label>
        </m-col>
      </m-row>

      <m-row class="mt-4">
        <m-col md="8">
          <memlist-checkbox
            id="field-enabled_event_dintero"
            v-model="settings.enabled_event_dintero"
            :text="$t('EVENT.CHECKBOX_ENABLED_EVENT_DINTERO')"
          />
        </m-col>
      </m-row>


      <m-row class="mt-8">
        <m-col md="8">

          <memlist-text-input
            id="url-after-event-signup"
            v-model="settings.url_after_event_signup"
            :title="$t('EVENT.HEADER_URL_FORWARD')"
            :tooltip="$t('EVENT.TIP_URL_FORWARD')"
            layout="vertical"
            type="text"
            :placeholder="'https://memlist.se'"
          />

          <p>{{ $t('PAGES.SETTINGS.REQUIRES_HTTP') }}</p>
        </m-col>
      </m-row>

      <m-row class="mt-8">
        <m-col md="8">
          <memlist-button type="submit" variant="primary" @click.prevent="save_data">{{ $t('COMMON.SAVE') }}</memlist-button>
        </m-col>
      </m-row>
    </div>

  </div>

</template>


<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import TipLabel from '@/view/components/TipLabel.vue';
import RequiredFieldsInfo from '@/view/components/RequiredFieldsInfo.vue';
import ColorPickerInput from '@/view/components/ColorPickerInput';

export default {
  name: 'EventSettings',

  components: { TipLabel, RequiredFieldsInfo, ColorPickerInput },

  mixins: [ toasts ],

  computed: {
    ...mapGetters(['currentCompanyId']),
  },

  watch: {},

  methods: {
    on_image_xl_uploaded(file) {
      this.settings.public_event.image_xl_file_id = file.file_id;
      this.xl_preview_url = file.public_path;

      this.save_data();
    },

    async load_settings() {
      try {
        const response = await axios.get(`/company/${this.currentCompanyId}`);
        this.settings = response.data.company_settings;
        this.settings.public_event = {};
      } catch (error) {
        this.toastr('danger', this.$t('COMMON.ERROR'), error);
      }
    },

    async save_data() {
      try {
        const response = await axios.put(`/company/company_settings/${this.currentCompanyId}`, {
          enabled_event_dintero: this.settings.enabled_event_dintero,
          subevents: this.settings.subevents,
          url_after_event_signup: this.settings.url_after_event_signup,
          public_event: this.settings.public_event,
        });

        if (response.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('PAGES.SETTINGS.UPDATED'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.SETTINGS.UNABLE_UPDATE'));
        }
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.SETTINGS.UNABLE_UPDATE'));
      }
    },
  },

  mounted() {
    this.load_settings();
  },

  data() {
    return {
      xl_preview_url: null,
      settings: {
        public_event: {},
        subevents: false,
        enabled_event_dintero: false,
        url_after_event_signup: null
      }
    };
  }

};

</script>
